import * as React from "react";
import Box from "@mui/material/Box";
import { Theme } from "../styles/styles";
import { ThemeProvider } from "@mui/material/styles";
import { Typography } from "@mui/material";
import NoPhotographyOutlinedIcon from '@mui/icons-material/NoPhotographyOutlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
//import Img from "../../images/marketing/L6.png"


export const GoodDetailsBox = ({

    goodImg,
    goodTitle,
    goodDescription,
    goodDate,

}) => {

    const theDate = new Date(goodDate);
    //const nullImg = "";
    return (
        <ThemeProvider theme={Theme}>
            <Box
                id="mainBox"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "#F2F3F5",
                    pl: "24px",
                    justifyContent: "flex-start",
                    [Theme.breakpoints.down("tablet")]: {
                        width: "100vw",
                        minHeight: "547px",
                        //height:"100%"
                    },
                    [Theme.breakpoints.up("tablet")]: {
                        width: "60vw",
                        minHeight: "723px",
                        //borderRadius: "16px"
                    },
                    [Theme.breakpoints.up("laptop")]: {
                        width: "33vw",
                    },
                    [Theme.breakpoints.up("desktop")]: {
                        width: "35vw",
                        minHeight:"unset",
                        maxHeight:"73hv"
                    },

                }}
            >


                {goodImg ? (
                    <Box
                        component="img"
                        src={goodImg}
                        alt="Obraz produktu"
                        sx={{
                            width: "100%",
                            maxHeight: "30vh",
                            height: "auto",
                            objectFit: "contain",
                            mt: "16px",
                            bgcolor: "#f2f2f2",
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: "100%",
                            maxHeight: "30vh",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mt: "16px",
                            bgcolor: "#f2f2f2",
                        }}
                    >
                        <NoPhotographyOutlinedIcon sx={{ fontSize: "80px", color: "#363636" }} />
                    </Box>
                )}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: "16px",
                        mt: "12px",

                        [Theme.breakpoints.up("tablet")]: {
                            alignSelf: "flex-end"
                        },
                    }}>

                    <CalendarTodayIcon
                        sx={{
                            fontSize: 14,
                            color: "#f29a26",
                            mr: "6px",
                        }}
                    />

                    <Typography variant="bodyMediumReguralLinks"

                    >{theDate.toLocaleDateString("pl-pl", {
                        //weekday: "short",
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                    })}
                    </Typography>

                </Box>

                <Typography variant="subtitle" sx={{ alignSelf: "flex-start", mb: "16px", mt: "16px" }}

                >{goodTitle}
                </Typography>
                <Typography variant="bodySmallRegural" sx={{ alignSelf: "flex-start", fontSize: "12px", }}

                >{goodDescription}
                </Typography>


            </Box>
        </ThemeProvider>

    );
};


